import {
  Add,
  ArchiveSharp,
  Close,
  CloseSharp,
  Delete,
  DeleteSharp,
  DraftsSharp,
  PaymentSharp,
  PreviewSharp,
  RequestQuoteSharp,
  SaveSharp,
  Send
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  Table,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useContext, useEffect, useState } from "react";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
import PaymentsModel from "../PaymentsModel";
import InvoicePreview from "../Reports/InvoicePreview";

import { useTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import axios from "../../axiosInstances";

export default function SalesNewOrder(props) {
  const theme = useTheme();
  var fileObj = [];
  var fileArray = [];
  const [update, setUpdate] = useState(false);
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const fullScreenValue = useMediaQuery(theme.breakpoints.down('md'));
  const [orderDate, setOrderDate] = useState(
    props.data ? props.data.VoucherDate : format(new Date(), "yyyy-MM-dd")
  );
  const {
    addtoCart,
    setSelectedItems,
    removeFromCart,
    globalUser,
    selectedItems,
    allItems,
    globalCustomers,
    globalSelectedCustomers,
    setGlobalSelectedCustomers,
    globalRoleSecurity,
    globalStores,
    globalToken,
    selectedSalesType
  } = useContext(ShoppingCartContext);
  const [lineItems, setLineItems] = useState(props?.LineItems);
  const [bankList, setBankList] = useState(props?.BankList);

  const [selectedVoucher, setSelectedVoucher] = useState(
    props.data
      ? props.data
      : globalSelectedCustomers && globalSelectedCustomers.length > 0
        ? { Customer: globalSelectedCustomers[0]?.Id }
        : { Customer: globalCustomers[0]?.Id }
  );

  const [customers, setCustomers] = useState(
    props.data
      ? [
        {
          ...props?.data,
          Id: props?.data?.Customer,
          Customer: props?.data?.Customer,
        },
      ]
      : globalSelectedCustomers && globalSelectedCustomers.length > 0
        ? globalSelectedCustomers
        : [
          {
            ...globalCustomers[0],
            VoucherDate: orderDate,
            Status: props?.Status,
          },
        ]
  );

  const [Photofiles, setPhotofiles] = useState(splitPictures());

  const [deliveryLines] = useState(props.DeliveryLines);
  const [paymentsOrderList] = useState(props.PaymentList);
  const getPaidAmount = (cust) => {

    var paidAmount = 0;

    paymentsOrderList?.filter((pay) => (pay.OrderNo == cust.OrderId)).map((pay) => {

      paidAmount = parseFloat(paidAmount) + parseFloat(pay.Amount?.toString().replace(",", ""))
    })


    return paidAmount

  }
  const [paidAmount] = useState()

  const [sourceNo, setSourceNo] = useState(props.SourceNo ? props.SourceNo : 0);
  const [storeList, setStoreList] = useState(globalStores);
  const [store, setStore] = useState(
    props.data
      ? storeList.filter((st) => parseInt(st.Id) === parseInt(props.data.Store))
        .length > 0 &&
      storeList.filter(
        (st) => parseInt(st.Id) === parseInt(props.data.Store)
      )[0]?.Name
      : globalUser.Store && globalUser.Store !== 0 ? storeList.filter((st) => parseInt(st.Id) === parseInt(globalUser.Store))
        .length > 0 &&
        storeList.filter(
          (st) => parseInt(st.Id) === parseInt(globalUser.Store)
        )[0]?.Name : storeList[0]?.Name
  );
  function splitPictures() {
    try {
      fileArray = [];
      props.data?.Attachment?.split(",").map(function (address, index) {
        if (!fileArray.includes(address) && address.length > 0) {
          fileArray.push(address);
          //document.getElementById('file').files.push(new Blob(address))
        }
      });
      return fileArray;
    } catch (err) {
      console.log(err);
    }
  }
  function uploadMultipleFiles(e) {
    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }
    setPhotofiles(fileArray);
  }
  const handleSynch = () => {

    axios
      .post(
        "/vouchers/createorder",
        {
          headers: {
            token: globalToken,
          },
        }
      )



  };
  const handleSubmit = (orderId, status, type, vDate, lItems) => {

    let testResult = false;
    customers &&
      customers.map((cust, index) => {
        if ((cust.Customer === undefined || cust.Customer === null || cust.Customer === 0) && (status !== "Quote") && (status !== "Request")) {
          alert(
            "First select the supplier for SO :" +
            (parseInt(index) + parseInt(1))
          );
          testResult = true;
          return;
        }

        if (
          store === undefined ||
          store === null ||
          store === false ||
          store === 0
        ) {
          alert(
            "First select the store for SO :" + (parseInt(index) + parseInt(1))
          );
          testResult = true;
          return;
        }
        if (
          lItems === undefined ||
          lItems.filter(
            (li) =>
              li.Name.length > 0 && parseInt(li.Customer) === parseInt(cust.Customer)
          ).length <= 0
        ) {
          alert(
            "First select the items in SO :" + (parseInt(index) + parseInt(1))
          );
          testResult = true;
          return;
        }

        lItems.map((li) => {
          if (isNaN(li.Quantity) || li.Quantity <= 0) {
            alert(
              "First insert the proper quantity of product: " +
              li.Name +
              " in  PO :" +
              (parseInt(index) + parseInt(1))
            );
            testResult = true;
            return;
          }

          if (isNaN(li.UnitPrice) || li.UnitPrice <= 0) {
            alert(
              "First insert the proper unit price of product: " +
              li.Name +
              " in  PO :" +
              (parseInt(index) + parseInt(1))
            );
            testResult = true;
            return;
          }

          var deliveredQuantity = 0;
          deliveryLines !== undefined && deliveryLines.filter((dl) => dl.Name === li.Name).map((dli) => {
            deliveredQuantity = parseFloat(deliveredQuantity) + parseFloat(dli.Quantity);
          });
          if (parseFloat(li.Quantity) < parseFloat(deliveredQuantity)) {
            alert(
              "The delivered Quantity: " + deliveredQuantity + " is greater than the sales order quantity: " + li.Quantity + " for item: " +
              li.Name +
              " in  PO :" +
              (parseInt(index) + parseInt(1))
            );
            testResult = true;
            return;
          }

        });
        if (testResult) {
          return;
        }

        if (
          window.confirm(
            "Are you sure you want to save the " +
            props.Type +
            " " +
            status +
            "?"
          )
        ) {
          try {
            var fd = new FormData();
            fd.append("OrderId", orderId);
            fd.append("Supplier", globalUser.Parent);
            fd.append("VoucherDate", vDate);

            fd.append("Amount", isNaN(cust.Amount) ? 0 : cust.Amount.toLocaleString().replace(",", ""));
            fd.append(
              "VATAmount",
              cust.VATAmount.toLocaleString().replace(",", "")
            );

            fd.append(
              "TotalAmount",
              isNaN(cust.TotalAmount) ? 0 : cust.TotalAmount.toLocaleString().replace(",", "")
            );
            fd.append("Customer", cust.Customer);
            fd.append("SourceNo", sourceNo);
            fd.append("Status", status);
            fd.append("BillTo", globalUser.Id);

            fd.append("Store", (storeList.filter(
              (st) => st.Name === store)
            )[0]?.Id);
            fd.append("User", globalUser.Id);


            if (Array.from(document.getElementById("Attachment").files).length > 0) {
              Array.from(document.getElementById("Attachment").files).map((file) => {
                fd.append("Attachment", file);
              });
            } else {
              fd.append("OriginalAttachment", Photofiles[0]?.replace("https://ethiob2b.com", ""));
            }

            fd.append(
              "LineItems",
              JSON.stringify(
                lItems.filter(
                  (it) =>
                    it.Name.length > 0 &&
                    parseInt(it.Customer) === parseInt(cust.Customer)
                )
              )
            );
            fd.append("Type", type);
            fd.append("Parent", globalUser.Parent);
            axios.post("/vouchers", fd, {
              headers: {
                "Content-Type": "multipart/form-data",
                token: globalToken,
              },
            }).then(() => {
              setSelectedItems([]);
              setGlobalSelectedCustomers([]);
              setLineItems([]);
              try {
                props.setParentUpdate(!props.ParentUpdate);
              } catch (err) { }

              setOpen(false);

            });
          } catch (err) { }


        }
      });
  };
  const handleDelete = (id) => {

    axios
      .get(
        "/vouchers/getChildVouchers?SourceNo=" +
        id,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {

        if (response.data.data === undefined || response.data.data == 0) {

          if (window.confirm("Are you sure you want to delete?")) {
            try {
              axios.delete("/vouchers?Id=" + id, {
                headers: {
                  token: globalToken,
                },
              }); //add id
            } catch (err) {
            } finally {
              props.setParentUpdate(!props.ParentUpdate);
              setOpen(false);
            }
          } else {
            return 0;
          }
        } else {
          alert("There are related vouchers. First delete them.");
          return;
        }
      }
      );

  };
  const handleLineItemDelete = (id) => {
    try {
      axios
        .delete("/lineItems?Id=" + id, {
          headers: {
            token: globalToken,
          },
        })
        .then(() => setLineItems(lineItems.filter((li) => li.Id !== id))); //add id
    } catch (err) {
    } finally {
    }
  };
  const handleChangeStatus = (id, status) => {
    lineItems && lineItems.map((item) => {

      var deliQty = 0;
      deliveryLines && deliveryLines.filter((delIt) => delIt.Item == item.Item).map((delItem) => {
        deliQty = deliQty + delItem.Quantity
      })

      if (item.Quantity > deliQty) {
        alert("Delivery Quantity for Item: " + item.Name + " is " + deliQty + " which is less than the order quantity: " + item.Quantity)
      }
      deliQty = 0;
    })

    customers &&
      customers.map((cust, index) => {

        if (getPaidAmount(cust) < cust.TotalAmount) {
          alert("Paid Amount: " + getPaidAmount(cust)?.toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          ) + " is less than the order Total Amount: " + cust.TotalAmount?.toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          ))
        }
      })


    if (window.confirm("Are you sure you want Archived?")) {
      try {
        axios.get("/vouchers/ChangeStatus?Id=" + id + "&Status=" + status, {
          headers: {
            token: globalToken,
          },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  useEffect(() => {

    try {
      if (
        customers === undefined ||
        customers === null ||
        customers.length <= 0
      ) {
        setCustomers(
          props.data
            ? [
              {
                ...props.data,
                Id: props.data.Customer,
                Customer: props.data.Customer,
                Amount: 0,
                VATAmount: 0,
                TotalAmount: 0,
                Store: props.data.Store,
              },
            ]
            : globalSelectedCustomers && globalSelectedCustomers.length > 0
              ? globalSelectedCustomers
              : [{ ...globalCustomers[0], Status: props.Status }]
        );

        setSelectedVoucher(
          props.data
            ? props.data.Customer
            : globalSelectedCustomers && globalSelectedCustomers.length > 0
              ? globalSelectedCustomers[0]
              : { Customer: 0 }
        );
      }
      if (!(props.data === undefined) && !(props.data === null)) {
        setLineItems([...props.LineItems, ...selectedItems]);
      } else {
        setLineItems(selectedItems.filter((itt) => itt.Type === "Sales"));
      }
    } catch { }

  }, [selectedItems, globalSelectedCustomers]);
  return (
    <div>
      <label
        onClick={() => {
          setOpen(true);
        }}
      >
        {props.icon}
      </label>

      <Dialog
        maxWidth="md"
        fullScreen={fullScreenValue}


        /*      PaperProps={{
           sx: {
             height: '80vh',   // 80% of viewport height
             maxHeight: '90vh',
           },
         }} */
        PaperProps={{
          style: {
            borderRadius: 24,
            backgroundColor: '#fffcf9', // Warm off-white
            boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
          }
        }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >

        <DialogContent>
          <DialogContentText>
            {!(customers === undefined) &&
              !(customers === null) &&
              customers.length > 0 &&
              customers.map((cust, index) => {

                if (
                  cust &&
                  !(cust === null) &&
                  (cust.CustomerName &&
                    cust.CustomerName.length > 0 || cust.Customer === 0)
                ) {
                  cust.VATAmount = 0;
                  cust.Amount = 0;
                  lineItems &&
                    lineItems
                      .filter(
                        (li) => (parseInt(li.Customer) === parseInt(cust.Customer) || parseInt(li.Customer) === 0)
                      )
                      .map((it) => {
                        cust.VATAmount = parseFloat(cust.VATAmount) + parseFloat(it.TaxAmount);
                        cust.Amount = parseFloat(cust.Amount) + parseFloat(it.TotalPrice);
                      });
                  cust.TotalAmount = parseFloat(cust.Amount) + parseFloat(cust.VATAmount);
                  return (
                    <>
                      <DialogTitle
                        style={{
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.primary.contrastText,

                        }}
                        onClick={() => {
                          cust.Customer !== selectedVoucher?.Customer
                            ? setSelectedVoucher((pre) =>
                            ({
                              Customer: customers[
                                index + 1 >= customers.length ? 0 : index + 1
                              ].Id
                            })
                            )
                            : setSelectedVoucher((pre) => ({ Customer: 0 }))

                        }
                        }
                      >
                        <Stack direction='row' style={{ flex: 1 }}>
                          <Stack direction={fullScreenValue ? 'column' : 'row'} style={{ flex: 1 }}>
                            <Typography variant="body3" sx={{ alignItems: 'flex-start' }}>
                              SO: {index + 1 + "              "} Customer:{" " + cust.CustomerName}
                            </Typography>
                            <Typography variant="body3" sx={{ alignItems: fullScreenValue ? "flex-start" : "flex-end", flex: 1, textAlign: fullScreenValue ? 'left' : 'right', marginRight: 1, marginTop: fullScreenValue ? 0 : -2 }} >
                              {"Total Amount: " + cust.TotalAmount?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              }
                              <br></br>
                              <Typography variant="body3" sx={{ alignItems: "flex-end", flex: 1, textAlign: 'right' }} >
                                {"Paid Amount:  " + getPaidAmount(cust)?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}

                              </Typography>

                            </Typography>
                          </Stack>
                          <Typography style={{ marginLeft: 20, marginTop: -3, marginRight: -5, textAlign: 'right' }}>
                            <IconButton style={{ background: theme.palette.primary.light, alignItems: 'center', justifyItems: 'center' }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
                          </Typography>
                        </Stack>



                      </DialogTitle>

                      <Grid container mt={1} key={cust.Customer}>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        >

                          <Autocomplete
                            label="Customer"
                            id="Customer"
                            size="small"
                            variant="standard"
                            defaultValue={cust.CustomerName}
                            onChange={(e) => {
                              customers[index] =
                                globalCustomers.filter(
                                  (ss) => ss.CustomerName === e.target.textContent
                                ).length > 0 &&
                                globalCustomers.filter(
                                  (ss) => ss.CustomerName === e.target.textContent
                                )[0];

                              setLineItems(
                                lineItems
                                  .filter((lil) => lil.Customer === cust.Customer)
                                  .map((li) => {
                                    li.Customer = customers[index].Id;
                                    return li;
                                  })
                              );
                              setSelectedVoucher({ Customer: customers[index].Id });

                              setCustomers(
                                customers.map((sp) => {
                                  return sp;
                                })
                              );
                            }}
                            options={
                              !(globalCustomers === undefined) &&
                              !(globalCustomers === null) &&
                              globalCustomers.length > 0 &&
                              globalCustomers.map((pro) => {
                                return pro.CustomerName;
                              })
                            }
                            sx={{ width: "95%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("Customer")}

                              //error={!from ? true : false}
                              />
                            )}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        >
                          <span style={{}}>
                            Doc. No.: {props.data ? props.data.OrderId : 0}
                            {"      "}Status:{" "}
                            {props.data ? props.data?.Status : selectedSalesType ? selectedSalesType : "Quote"}
                          </span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          mt={1}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        >
                          <Autocomplete
                            label="Issued To"
                            id="Store"
                            size="small"
                            variant="standard"
                            defaultValue={store}
                            onChange={(event, newValue) => {

                              setStore(newValue);
                              cust.Store =
                                storeList &&
                                storeList.length > 0 &&
                                storeList.filter(
                                  (st) => st.Name === newValue
                                ).length > 0 &&
                                storeList.filter(
                                  (st) => st.Name === newValue
                                )[0]?.Id;
                              setCustomers(cs => cs)
                            }}

                            options={
                              (!(storeList === undefined) &&
                                !(storeList === null) &&
                                storeList.length > 0) ?
                                storeList.map((pro) => {
                                  return pro.Name;
                                }) : ['']
                            }
                            sx={{ width: "95%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("Store")}

                              //error={!from ? true : false}
                              />
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          mt={1}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        >
                          <TextField
                            size="small"
                            label="Order Date"
                            type="date"
                            value={
                              props.data ? props.data.VoucherDate : orderDate
                            }
                            onChange={(e) => {
                              setOrderDate(e.target.value);
                            }}
                            sx={{ width: "70%", marginBottom: 1 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        ></Grid>

                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            display:
                              selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                          }}
                        >
                          User:{" "}
                          {props.data ? props.data.UserName : globalUser.Name}
                        </Grid>

                        <Grid item xs={12}>
                          <Grid
                            direction="row"
                            container
                            style={{
                              display:
                                selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                            }}
                          >
                            <hr></hr>
                            <Grid item xs={12} className="hideInMobile">
                              <Grid container>
                                <Grid
                                  item
                                  xs={1}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  No.
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {" "}
                                  Item Name
                                </Grid>

                                <Grid
                                  item
                                  xs={2}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  Quantity
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  Unit Price
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  Total
                                </Grid>
                                <Grid
                                  item
                                  xs={1}
                                  style={{
                                    paddingLeft: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >

                                  {globalRoleSecurity.filter(
                                    (sec) =>
                                      sec.Functionality ===
                                      "Sales " +
                                      (props.Status
                                        ? props.Status
                                        : "Quote") && sec.Security > 1
                                  ).length > 0 && (
                                      <IconButton
                                        size="small"
                                        id={cust.Customer}
                                        onClick={(e) => {
                                          if (
                                            lineItems &&
                                            lineItems.filter(
                                              (itt) =>
                                                itt.Item === "" &&
                                                parseInt(itt.Customer) ===
                                                parseInt(cust.Customer)
                                            ).length <= 0
                                          ) {
                                            let newLineItem = {};
                                            newLineItem.Item = "";
                                            newLineItem.Name = "";
                                            newLineItem.Type = "Sales";
                                            newLineItem.Customer = cust.Customer;
                                            newLineItem.UnitCost = 0;
                                            newLineItem.Quantity = 0;
                                            newLineItem.UnitPrice = 0;
                                            newLineItem.TotalPrice = 0;
                                            newLineItem.TaxAmount = 0;
                                            newLineItem.CustomerName = cust.CustomerName;

                                            setSelectedItems((xx) => [
                                              ...xx,
                                              newLineItem,
                                            ]);
                                          } else {
                                            alert("First complete the data");
                                          }
                                        }}
                                      >
                                        <Add
                                          sx={{
                                            color:
                                              theme.palette.primary.contrastText,
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                </Grid>
                                {lineItems &&
                                  lineItems.length > 0 &&
                                  lineItems
                                    .filter(
                                      (itm) =>
                                        parseInt(itm.Customer) ===
                                        parseInt(cust.Customer)
                                    )
                                    .map((item, index) => {

                                      return (
                                        <>
                                          <Grid item xs={12}>
                                            <hr></hr>
                                          </Grid>
                                          <Grid item xs={1} key={index}>
                                            {index + 1}
                                          </Grid>
                                          <Grid item xs={4}>
                                            <Autocomplete
                                              label="Items"
                                              id="Items"
                                              autoHighlight
                                              size="small"
                                              variant="standard"
                                              value={item.Name}
                                              onChange={(e) => {
                                                if (
                                                  lineItems &&
                                                  lineItems.length > 0 &&
                                                  lineItems === null &&
                                                  lineItems.filter(
                                                    (li) =>
                                                      li.Name ===
                                                      e.target.textContent &&
                                                      parseInt(li.Customer) ===
                                                      parseInt(cust.Customer)
                                                  ).length > 0
                                                ) {
                                                  item.Item = "";
                                                  item.Name = "";
                                                  item.Customer = cust.Customer;
                                                  item.Quantity = 0;
                                                  item.UnitPrice = 0;
                                                  item.UnitCost = 0;
                                                  item.TotalPrice = 0;
                                                  item.TaxAmount = 0;
                                                  setSelectedItems(
                                                    selectedItems.map(
                                                      (litem) => {
                                                        return litem;
                                                      }
                                                    )
                                                  );
                                                  //alert('The selected item is already registered')
                                                  return;
                                                } else {
                                                  let selectedProduct =
                                                    allItems.filter(
                                                      (selItem) =>
                                                        selItem.Name ==
                                                        e.target.textContent
                                                    );
                                                  if (
                                                    selectedProduct &&
                                                    selectedProduct.length > 0
                                                  ) {
                                                    item.Type = "Sales";
                                                    item.Quantity =
                                                      selectedProduct[0].DefaultOrderQty !== 0
                                                        ? selectedProduct[0]
                                                          .DefaultOrderQty
                                                        : 1;
                                                    item.UnitPrice =
                                                      selectedProduct[0].Price
                                                        ? selectedProduct[0]
                                                          .Price
                                                        : 0;
                                                    item.VATInclusive =
                                                      selectedProduct[0].VATInclusive;
                                                    item.TaxAmount =
                                                      item.VATInclusive
                                                        ? item.UnitPrice * 0.15
                                                        : 0;
                                                    item.Customer = cust.Customer;

                                                    item.UOM =
                                                      selectedProduct[0].UOM
                                                        ? selectedProduct[0].UOM
                                                        : "PCS";

                                                    item.Item =
                                                      selectedProduct[0].Item;
                                                    item.Name =
                                                      selectedProduct[0].Name;
                                                    item.TotalPrice =
                                                      item.UnitPrice *
                                                      item.Quantity;
                                                    item.TaxAmount =
                                                      selectedProduct[0]
                                                        .VATInclusive
                                                        ? item.UnitPrice *
                                                        item.Quantity *
                                                        0.15
                                                        : 0;
                                                    item.Image =
                                                      selectedProduct[0].Picture;
                                                    item.Customer = cust.Customer;
                                                    cust.VATAmount = 0;
                                                    cust.Amount = 0;
                                                    lineItems &&
                                                      lineItems
                                                        .filter(
                                                          (li) =>
                                                            parseInt(
                                                              li.Customer
                                                            ) ===
                                                            parseInt(cust.Customer)
                                                        )
                                                        .map((it) => {
                                                          cust.VATAmount =
                                                            cust.VATAmount +
                                                            it.TaxAmount;
                                                          cust.Amount =
                                                            cust.Amount +
                                                            it.TotalPrice;
                                                        });
                                                    cust.TotalAmount =
                                                      cust.Amount +
                                                      cust.VATAmount;
                                                    addtoCart(item);

                                                    setSelectedItems(
                                                      selectedItems.map(
                                                        (litem) => {
                                                          return litem;
                                                        }
                                                      )
                                                    );
                                                  } else {
                                                    item.Quantity = 0;
                                                    item.UnitPrice = 0;
                                                    item.UnitCost = 0;
                                                    item.TotalPrice = 0;
                                                    item.TaxAmount = 0;
                                                    item.Item = "";
                                                    item.Name = "";
                                                    item.Customer = cust.Customer;

                                                    setSelectedItems(
                                                      selectedItems.map(
                                                        (litem) => {
                                                          return litem;
                                                        }
                                                      )
                                                    );
                                                  }
                                                }
                                              }}
                                              options={
                                                !(allItems === undefined) &&
                                                  !(allItems === null) &&
                                                  allItems.length > 0
                                                  ? allItems.map((it) => {
                                                    return it.Name;
                                                  })
                                                  : [""]
                                              }
                                              sx={{ width: "95%", height: 5 }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label={item.Name}
                                                  sx={{ height: 5 }}
                                                //error={!from ? true : false}
                                                />
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <TextField
                                              size="small"
                                              variant="standard"
                                              type="float"
                                              value={
                                                item.Quantity
                                                  ? item.Quantity.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }
                                                  )
                                                  : 0
                                              }
                                              maxRows={4}
                                              sx={{ width: "70px" }}
                                              onChange={(e) => {
                                                item.Quantity = e.target.value;
                                                item.TotalPrice =
                                                  item.Quantity *
                                                  item.UnitPrice;
                                                item.TaxAmount =
                                                  item.VATInclusive
                                                    ? item.TotalPrice * 0.15
                                                    : 0;
                                                cust.VATAmount = 0;
                                                cust.Amount = 0;
                                                lineItems &&
                                                  lineItems
                                                    .filter(
                                                      (li) =>
                                                        parseInt(
                                                          li.Customer
                                                        ) === parseInt(cust.Customer)
                                                    )
                                                    .map((it) => {
                                                      cust.VATAmount =
                                                        cust.VATAmount +
                                                        it.TaxAmount;
                                                      cust.Amount =
                                                        cust.Amount +
                                                        it.TotalPrice;
                                                    });
                                                cust.TotalAmount =
                                                  cust.Amount + cust.VATAmount;
                                                setSelectedItems(
                                                  selectedItems.map((litem) => {
                                                    return litem;
                                                  })
                                                );
                                              }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                            />
                                          </Grid>

                                          <Grid item xs={2}>
                                            <TextField
                                              size="small"
                                              variant="standard"
                                              type="float"
                                              value={
                                                item.UnitPrice
                                                  ? item.UnitPrice.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }
                                                  )
                                                  : 0
                                              }
                                              sx={{ width: "70px" }}
                                              onChange={(e) => {
                                                item.UnitPrice = e.target.value;
                                                item.TotalPrice =
                                                  item.Quantity *
                                                  item.UnitPrice;
                                                item.TaxAmount =
                                                  item.VATInclusive
                                                    ? item.TotalPrice * 0.15
                                                    : 0;
                                                cust.VATAmount = 0;
                                                cust.Amount = 0;
                                                lineItems &&
                                                  lineItems
                                                    .filter(
                                                      (li) =>
                                                        parseInt(
                                                          li.Customer
                                                        ) === parseInt(cust.Customer)
                                                    )
                                                    .map((it) => {
                                                      cust.VATAmount =
                                                        cust.VATAmount +
                                                        it.TaxAmount;
                                                      cust.Amount =
                                                        cust.Amount +
                                                        it.TotalPrice;
                                                    });

                                                cust.TotalAmount =
                                                  cust.Amount + cust.VATAmount;
                                                setSelectedItems(
                                                  selectedItems.map((litem) => {
                                                    return litem;
                                                  })
                                                );
                                              }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                            />
                                          </Grid>
                                          <Grid item xs={2}>
                                            {item.TotalPrice.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )}
                                          </Grid>
                                          <Grid item xs={1}>
                                            {globalRoleSecurity.filter(
                                              (sec) =>
                                                sec.Functionality ===
                                                "Sales " +
                                                (props.Status
                                                  ? props.Status
                                                  : "Quote") &&
                                                sec.Security > 1
                                            ).length > 0 && (
                                                <Tooltip title="remove">
                                                  <Button
                                                    endIcon={
                                                      <Delete
                                                        sx={{
                                                          color:
                                                            theme.palette.primary
                                                              .main,
                                                        }}
                                                      />
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        lineItems.filter(
                                                          (litem) =>
                                                            parseInt(
                                                              litem.Item
                                                            ) ===
                                                            parseInt(
                                                              item.Item
                                                            ) &&
                                                            parseInt(
                                                              litem.Customer
                                                            ) ===
                                                            parseInt(
                                                              item.Customer
                                                            )
                                                        ).length > 0
                                                      ) {
                                                        handleLineItemDelete(
                                                          lineItems.filter(
                                                            (litem) =>
                                                              parseInt(
                                                                litem.Item
                                                              ) ===
                                                              parseInt(
                                                                item.Item
                                                              ) &&
                                                              parseInt(
                                                                litem.Customer
                                                              ) ===
                                                              parseInt(
                                                                item.Customer
                                                              )
                                                          )[0].Id
                                                        );
                                                      }
                                                      removeFromCart(item);

                                                      /*    setLineItems(
                                      lineItems.filter(
                                        (litem) => !(litem.Item === item.Item && parseInt(litem.Customer)===parseInt(item.Customer))
                                      )
                                    ); */
                                                      if (
                                                        lineItems.filter(
                                                          (litem) =>
                                                            parseInt(
                                                              litem.Customer
                                                            ) ===
                                                            parseInt(cust.Customer)
                                                        ).length <= 0
                                                      ) {
                                                        setCustomers(
                                                          customers.filter(
                                                            (ssp) =>
                                                              parseInt(ssp.Id) !==
                                                              parseInt(cust.Customer)
                                                          )
                                                        );
                                                        /* setOpen(false);
                                                     let newLineItem = {};
                                      newLineItem.Item = "";
                                      newLineItem.Name = "";
                                      newLineItem.Customer = cust.Customer;
                                      newLineItem.UnitCost = 0;
                                      newLineItem.Quantity = 0;
                                      newLineItem.UnitPrice = 0;
                                      newLineItem.TotalPrice = 0;
                                      setLineItems((xx) => [...xx, newLineItem]); */
                                                      }
                                                    }}
                                                  ></Button>
                                                </Tooltip>
                                              )}
                                          </Grid>
                                        </>
                                      );
                                    })}
                                <Grid item xs={12}>
                                  <hr></hr>
                                </Grid>
                                <Grid item xs={5}></Grid>
                                <Grid
                                  item
                                  xs={4}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {" "}
                                  Sub Total:
                                </Grid>

                                <Grid
                                  item
                                  xs={3}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    textDecoration: "underline",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {cust.Amount?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Grid>

                                <Grid item xs={5}></Grid>
                                <Grid
                                  item
                                  xs={4}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {" "}
                                  VAT Amount:
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                    textDecorationLine: "underline",
                                  }}
                                >
                                  {cust.VATAmount?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Grid>
                                <Grid item xs={5}></Grid>
                                <Grid
                                  item
                                  xs={4}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {" "}
                                  Total Amounttt:

                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  style={{
                                    border: "solid 1",
                                    padding: "5px",
                                    textDecoration: "underline",
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                  }}
                                >
                                  {" "}
                                  {parseFloat(cust.TotalAmount)?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}{" "}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item className="hideInFull" m={1} xs={12}>
                              <Grid
                                style={{
                                  border: "solid 1",
                                  padding: "5px",
                                  backgroundColor: theme.palette.primary.main,
                                  color: theme.palette.primary.contrastText,
                                }}
                                xs={12}
                                onClick={(e) => {
                                  if (
                                    lineItems &&
                                    lineItems.filter(
                                      (itt) =>
                                        itt.Item === "" &&
                                        parseInt(itt.Customer) ===
                                        parseInt(cust.Customer)
                                    ).length <= 0
                                  ) {
                                    let newLineItem = {};
                                    newLineItem.Item = "";
                                    newLineItem.Name = "";
                                    newLineItem.Type = "Sales";
                                    newLineItem.Customer = cust.Customer;
                                    newLineItem.UnitCost = 0;
                                    newLineItem.Quantity = 0;
                                    newLineItem.UnitPrice = 0;
                                    newLineItem.TotalPrice = 0;
                                    newLineItem.TaxAmount = 0;
                                    newLineItem.CustomerName = cust.CustomerName;

                                    setSelectedItems((xx) => [
                                      ...xx,
                                      newLineItem,
                                    ]);
                                  } else {
                                    alert("First complete the data");
                                  }
                                }}
                              >
                                + Add new line item
                              </Grid>
                              {lineItems &&
                                lineItems.length > 0 &&
                                lineItems
                                  .filter(
                                    (it) =>
                                      parseInt(it.Customer) ===
                                      parseInt(cust.Customer)
                                  )
                                  .map((item, index) => {
                                    return (
                                      <>
                                        <Card
                                          sx={{
                                            borderRadius: 10,
                                            boxShadow: 3,
                                            width: "100%",
                                          }}
                                        >
                                          <CardContent>
                                            <Grid container xs={12}>
                                              <Grid item xs={4}>
                                                No.:
                                              </Grid>
                                              <Grid item xs={8} pl={0}>
                                                {index + 1}
                                              </Grid>
                                              <Grid item xs={4}>
                                                Product:
                                              </Grid>
                                              <Grid item xs={8} pl={0}>
                                                <Autocomplete
                                                  label="Items"
                                                  id="Items"
                                                  autoHighlight
                                                  size="small"
                                                  variant="standard"
                                                  value={item.Name}
                                                  onChange={(e) => {
                                                    if (
                                                      lineItems &&
                                                      lineItems.length > 0 &&
                                                      lineItems === null &&
                                                      lineItems.filter(
                                                        (li) =>
                                                          li.Name ===
                                                          e.target
                                                            .textContent &&
                                                          parseInt(
                                                            li.Customer
                                                          ) ===
                                                          parseInt(cust.Customer)
                                                      ).length > 0
                                                    ) {
                                                      item.Item = "";
                                                      item.Name = "";
                                                      item.Customer = cust.Customer;
                                                      item.Quantity = 0;
                                                      item.UnitPrice = 0;
                                                      item.UnitCost = 0;
                                                      item.TotalPrice = 0;
                                                      item.TaxAmount = 0;
                                                      setSelectedItems(
                                                        selectedItems.map(
                                                          (litem) => {
                                                            return litem;
                                                          }
                                                        )
                                                      );
                                                      //alert('The selected item is already registered')
                                                      return;
                                                    } else {
                                                      let selectedProduct =
                                                        allItems.filter(
                                                          (selItem) =>
                                                            selItem.Name ==
                                                            e.target.textContent
                                                        );
                                                      if (
                                                        selectedProduct &&
                                                        selectedProduct.length >
                                                        0
                                                      ) {
                                                        item.Type = "Sales";
                                                        item.Quantity =
                                                          selectedProduct[0]
                                                            .DefaultOrderQty !==
                                                            0
                                                            ? selectedProduct[0]
                                                              .DefaultOrderQty
                                                            : 1;
                                                        item.UnitPrice =
                                                          selectedProduct[0]
                                                            .Price
                                                            ? selectedProduct[0]
                                                              .Price
                                                            : 0;
                                                        item.VATInclusive =
                                                          selectedProduct[0].VATInclusive;
                                                        item.TaxAmount =
                                                          item.VATInclusive
                                                            ? item.UnitPrice *
                                                            0.15
                                                            : 0;
                                                        item.Customer = cust.Customer;

                                                        item.UOM =
                                                          selectedProduct[0].UOM
                                                            ? selectedProduct[0]
                                                              .UOM
                                                            : "PCS";

                                                        item.Item =
                                                          selectedProduct[0].Item;
                                                        item.Name =
                                                          selectedProduct[0].Name;
                                                        item.TotalPrice =
                                                          item.UnitPrice *
                                                          item.Quantity;
                                                        item.TaxAmount =
                                                          selectedProduct[0]
                                                            .VATInclusive
                                                            ? item.UnitPrice *
                                                            item.Quantity *
                                                            0.15
                                                            : 0;
                                                        item.Image =
                                                          selectedProduct[0].Picture;
                                                        item.Customer = cust.Customer;
                                                        cust.VATAmount = 0;
                                                        cust.Amount = 0;
                                                        lineItems &&
                                                          lineItems
                                                            .filter(
                                                              (li) =>
                                                                parseInt(
                                                                  li.Customer
                                                                ) ===
                                                                parseInt(
                                                                  cust.Customer
                                                                )
                                                            )
                                                            .map((it) => {
                                                              cust.VATAmount =
                                                                cust.VATAmount +
                                                                it.TaxAmount;
                                                              cust.Amount =
                                                                cust.Amount +
                                                                it.TotalPrice;
                                                            });
                                                        cust.TotalAmount =
                                                          cust.Amount +
                                                          cust.VATAmount;
                                                        addtoCart(item);

                                                        setSelectedItems(
                                                          selectedItems.map(
                                                            (litem) => {
                                                              return litem;
                                                            }
                                                          )
                                                        );
                                                      } else {
                                                        item.Quantity = 0;
                                                        item.UnitPrice = 0;
                                                        item.UnitCost = 0;
                                                        item.TotalPrice = 0;
                                                        item.TaxAmount = 0;
                                                        item.Item = "";
                                                        item.Name = "";
                                                        item.Customer = cust.Customer;

                                                        setSelectedItems(
                                                          selectedItems.map(
                                                            (litem) => {
                                                              return litem;
                                                            }
                                                          )
                                                        );
                                                      }
                                                    }
                                                  }}
                                                  options={
                                                    !(allItems === undefined) &&
                                                      !(allItems === null) &&
                                                      allItems.length > 0
                                                      ? allItems.map((it) => {
                                                        return it.Name;
                                                      })
                                                      : [""]
                                                  }
                                                  sx={{
                                                    width: "95%",
                                                    height: 5,
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      label={item.Name}
                                                      sx={{ height: 5 }}
                                                    //error={!from ? true : false}
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid
                                                item
                                                xs={4}
                                                sx={{ marginTop: 3 }}
                                              >
                                                Quantity:
                                              </Grid>
                                              <Grid
                                                item
                                                xs={8}
                                                pl={0}
                                                sx={{ marginTop: 3 }}
                                              >
                                                <TextField
                                                  size="small"
                                                  variant="standard"
                                                  type="float"
                                                  value={
                                                    item.Quantity
                                                      ? item.Quantity.toLocaleString(
                                                        undefined,
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }
                                                      )
                                                      : 0
                                                  }
                                                  maxRows={4}
                                                  sx={{ width: "70px" }}
                                                  onChange={(e) => {
                                                    item.Quantity =
                                                      e.target.value;
                                                    item.TotalPrice =
                                                      item.Quantity *
                                                      item.UnitPrice;
                                                    item.TaxAmount =
                                                      item.VATInclusive
                                                        ? item.TotalPrice * 0.15
                                                        : 0;
                                                    cust.VATAmount = 0;
                                                    cust.Amount = 0;
                                                    lineItems &&
                                                      lineItems
                                                        .filter(
                                                          (li) =>
                                                            parseInt(
                                                              li.Customer
                                                            ) ===
                                                            parseInt(cust.Customer)
                                                        )
                                                        .map((it) => {
                                                          cust.VATAmount =
                                                            cust.VATAmount +
                                                            it.TaxAmount;
                                                          cust.Amount =
                                                            cust.Amount +
                                                            it.TotalPrice;
                                                        });
                                                    cust.TotalAmount =
                                                      cust.Amount +
                                                      cust.VATAmount;
                                                    setSelectedItems(
                                                      selectedItems.map(
                                                        (litem) => {
                                                          return litem;
                                                        }
                                                      )
                                                    );
                                                  }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Grid>

                                              <Grid item xs={4}>
                                                Unit Price:
                                              </Grid>
                                              <Grid item xs={8} pl={0}>
                                                <TextField
                                                  size="small"
                                                  variant="standard"
                                                  type="float"
                                                  value={
                                                    item.UnitPrice
                                                      ? item.UnitPrice.toLocaleString(
                                                        undefined,
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }
                                                      )
                                                      : 0
                                                  }
                                                  sx={{ width: "70px" }}
                                                  onChange={(e) => {
                                                    item.UnitPrice =
                                                      e.target.value;
                                                    item.TotalPrice =
                                                      item.Quantity *
                                                      item.UnitPrice;
                                                    item.TaxAmount =
                                                      item.VATInclusive
                                                        ? item.TotalPrice * 0.15
                                                        : 0;
                                                    cust.VATAmount = 0;
                                                    cust.Amount = 0;
                                                    lineItems &&
                                                      lineItems
                                                        .filter(
                                                          (li) =>
                                                            parseInt(
                                                              li.Customer
                                                            ) ===
                                                            parseInt(cust.Customer)
                                                        )
                                                        .map((it) => {
                                                          cust.VATAmount =
                                                            cust.VATAmount +
                                                            it.TaxAmount;
                                                          cust.Amount =
                                                            cust.Amount +
                                                            it.TotalPrice;
                                                        });
                                                    cust.TotalAmount =
                                                      cust.Amount +
                                                      cust.VATAmount;
                                                    setSelectedItems(
                                                      selectedItems.map(
                                                        (litem) => {
                                                          return litem;
                                                        }
                                                      )
                                                    );
                                                  }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Grid>
                                              <Grid item xs={4}>
                                                Total Price:
                                              </Grid>
                                              <Grid item xs={8} pl={8}>
                                                {(
                                                  item.UnitPrice * item.Quantity
                                                )?.toLocaleString(undefined, {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })}
                                              </Grid>
                                              <Grid item xs={12}>
                                                <hr></hr>
                                                Remove: {"   "}
                                                <Tooltip title="remove">
                                                  <Button
                                                    endIcon={
                                                      <Delete
                                                        sx={{
                                                          color:
                                                            theme.palette
                                                              .primary.main,
                                                        }}
                                                      />
                                                    }
                                                    onClick={() => {
                                                      handleLineItemDelete(
                                                        lineItems.filter(
                                                          (litem) =>
                                                            litem.Item ===
                                                            item.Item
                                                        )[0].Id
                                                      );
                                                      removeFromCart(item);
                                                      /*   setLineItems(
                                    lineItems.filter(
                                      (litem) => !(litem.Item === item.Item)
                                    )
                                  ); */
                                                      if (
                                                        lineItems.filter(
                                                          (litem) =>
                                                            !(
                                                              litem.Item ===
                                                              item.Item
                                                            )
                                                        ).length <= 0
                                                      ) {
                                                        let newLineItem = {};
                                                        newLineItem.Item = "";
                                                        newLineItem.Name = "";
                                                        newLineItem.Customer =
                                                          cust.Customer;
                                                        newLineItem.UnitCost = 0;
                                                        newLineItem.Quantity = 0;
                                                        newLineItem.UnitPrice = 0;
                                                        newLineItem.TaxAmount = 0;
                                                        newLineItem.TotalPrice = 0;
                                                        setSelectedItems(
                                                          (xx) => [
                                                            ...xx,
                                                            newLineItem,
                                                          ]
                                                        );
                                                      }
                                                    }}
                                                  ></Button>
                                                </Tooltip>
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Card>
                                        <hr></hr>
                                      </>
                                    );
                                  })}
                              <Table>
                                <tr>
                                  <td />
                                  <td hidden />
                                  <td />
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  >
                                    {" "}
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                    }}
                                    colSpan={2}
                                  >
                                    {" "}
                                    Sub Total:
                                  </td>

                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      textDecoration: "underline",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                    }}
                                  >
                                    {cust.Amount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                    hidden
                                  >
                                    {" "}
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  >
                                    {" "}
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  >
                                    {" "}
                                  </td>

                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                    }}
                                    colSpan={2}
                                  >
                                    {" "}
                                    VAT Amount:
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                      textDecorationLine: "underline",
                                    }}
                                  >
                                    {cust.VATAmount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                    hidden
                                  >
                                    {" "}
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  >
                                    {" "}
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                    }}
                                  >
                                    {" "}
                                  </td>

                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                    }}
                                    colSpan={2}
                                  >
                                    {" "}
                                    Total Amount:
                                    Pai
                                  </td>
                                  <td
                                    style={{
                                      border: "solid 1",
                                      padding: "5px",
                                      textDecoration: "underline",
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      color: theme.palette.primary.contrastText,
                                    }}
                                  >
                                    {" "}
                                    {parseFloat(cust.TotalAmount).toLocaleString(
                                      undefined,
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                      }
                                    )}{" "}
                                  </td>
                                </tr>
                              </Table>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            border={1}
                            style={{
                              display:
                                selectedVoucher?.Customer === cust.Customer ? "block" : "none",
                            }}
                          >
                            <label htmlFor="Attachment">
                              Uplaod necessary document here
                              <input
                                id="Attachment"
                                name="Attachment"
                                type="file"
                                multiple
                                hidden
                                onChange={uploadMultipleFiles}
                              />
                            </label>
                            {Photofiles && Photofiles.length > 0 && (
                              <Button
                                style={{ color: "red" }}
                                ml={4}
                                endIcon={<Close />}
                                onClick={() => {
                                  setPhotofiles([]);
                                }}
                              />
                            )}
                            <div className="form-group multi-preview">
                              {(Photofiles || []).map((address) => (
                                <img
                                  src={"https://ethiob2b.com" + address}
                                  alt="..."
                                  style={{ width: "100%", height: "100" }}
                                />
                              ))}
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  );
                }
              })}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontSize: "8px",
            flexWrap: 'wrap',
          }}
        >
          {/*       <Button
                    variant="standard"
                     sx={{ 
            borderRadius: 5,           
            fontSize: "10px",
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.light }
          }}
                    endIcon={<DeleteSharp />}
                    autoFocus
                    onClick={() => handleSynch()}
                  >
                    Synch
                  </Button> */}
          <hr></hr>
          {props.data && customers && customers.length > 0 && (
            <>
              <Button variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  textWrap: 'wrap',
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<PreviewSharp />}>

                <InvoicePreview
                  icon={<div style={{ fontSize: "10px" }}>Preview</div>}
                  Suppliers={customers}
                  LineItems={lineItems}
                  DocumentType={
                    "Sales " + (props.Status ? props.Status : selectedSalesType ? selectedSalesType : "Quote")
                  }
                  Type="Invoice"
                />

              </Button>
              |
            </>
          )}
          {props.Status !== "Direct" && (
            <>
              {props.data &&
                (props.data.Status === "Order" ||
                  props.data.Status === "Delivery") &&
                globalRoleSecurity.filter(
                  (sec) =>
                    sec.Functionality === "Sales Payment" && sec.Security > 1
                ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<PaymentSharp />}
                      autoFocus
                    >
                      <PaymentsModel
                        icon={<div style={{ fontSize: "10px" }}>Payment</div>}
                        OrderData={props.data}
                        BankList={bankList}
                        Type="Sales"
                        ParentUpdate={props.ParentUpdate}
                        setParentUpdate={props.setParentUpdate}
                      />

                    </Button>{" "}
                    |
                  </>
                )}

              {globalRoleSecurity.filter(
                (sec) => sec.Functionality === "Sales Order" && sec.Security > 1
              ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<SaveSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          props.data ? props.data.OrderId : 0,
                          "Order",
                          "Normal",
                          orderDate,
                          lineItems.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          )
                        )
                      }
                    >
                      Order
                    </Button>
                    |{" "}
                  </>
                )}
              {globalRoleSecurity.filter(
                (sec) =>
                  sec.Functionality === "Sales Quote" && sec.Security > 1
              ).length > 0 && (
                  <>

                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<RequestQuoteSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          props.data ? props.data.OrderId : 0,
                          "Quote",
                          "Normal",
                          orderDate,
                          lineItems.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          )
                        )
                      }
                    >
                      {t("Quote")}
                    </Button>
                    |{" "}
                    {/*   {props.data && props.data.Status === "Quote" && (
                    <>
                      <Button
                        variant="standard"
                         sx={{ 
            borderRadius: 5,           
            fontSize: "10px",
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.light }
          }}
                        endIcon={<EmailSharp />}
                        autoFocus
                      >
                        Email
                      </Button>
                      |
                    </>
                  )} */}

                    {globalRoleSecurity.filter(
                      (sec) =>
                        sec.Functionality === "Sales Draft" && sec.Security > 1
                    ).length > 0 && (
                        <>
                          <Button
                            variant="standard"
                            sx={{
                              borderRadius: 5,
                              fontSize: "10px",
                              backgroundColor: theme.palette.primary.main,
                              '&:hover': { backgroundColor: theme.palette.primary.light }
                            }}
                            endIcon={<DraftsSharp />}
                            autoFocus
                            onClick={() =>
                              handleSubmit(
                                props.data ? props.data.OrderId : 0,
                                "Draft",
                                "Normal",
                                orderDate,
                                lineItems.filter(
                                  (itt) => itt.Name && itt.Name.length > 0
                                )
                              )
                            }
                          >
                            {t("Draft")}
                          </Button>
                          |
                        </>
                      )}
                  </>
                )}

              {globalRoleSecurity.filter(
                (sec) =>
                  sec.Functionality === "Sales Archived" && sec.Security > 2
              ).length > 0 && props.data && props.data?.Status === "Order" && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<ArchiveSharp />}
                      autoFocus

                      onClick={() => handleChangeStatus(props.data.OrderId, "Archived")}
                    >
                      Archive
                    </Button>
                    |
                  </>
                )}

              {props.data &&
                globalRoleSecurity.filter(
                  (sec) =>
                    sec.Functionality === "Sales " + (props.data ? props.data.Status : props.Status) && sec.Security > 2
                ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<DeleteSharp />}
                      autoFocus
                      onClick={() => handleDelete(props.data ? props.data.OrderId : 0,)}
                    >
                      Delete
                    </Button>
                    |
                  </>
                )}
            </>
          )}
          {props.Status === "Direct" && (
            <>
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<Send />}
                autoFocus
                onClick={() =>
                  handleSubmit(
                    props.data ? props.data.OrderId : 0,
                    "Order",
                    "DO",
                    orderDate,
                    lineItems.filter((itt) => itt.Name && itt.Name.length > 0)
                  )
                }
              >
                Direct Order
              </Button>
              |
            </>
          )}
          {(props.Status === "Direct" || props.Status === "Direct Delivery") &&
            globalRoleSecurity.filter(
              (sec) =>
                sec.Functionality === "Purchase Direct" && sec.Security > 1
            ).length > 0 && (
              <>
                <Button
                  variant="standard"
                  sx={{
                    borderRadius: 5,
                    fontSize: "10px",
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.light }
                  }}
                  endIcon={<Send />}
                  autoFocus
                  onClick={() =>
                    handleSubmit(
                      props.data ? props.data.OrderId : 0,
                      "Order",
                      "DOD",
                      orderDate,
                      lineItems.filter((itt) => itt.Name && itt.Name.length > 0)
                    )
                  }
                >
                  Direct Delivery
                </Button>
                |
              </>
            )}
          {(props.Status === "Direct" ||
            props.Status === "Direct D&P") &&
            globalRoleSecurity.filter(
              (sec) =>
                sec.Functionality === "Purchase Direct" && sec.Security > 1
            ).length > 0 && (
              <>
                <Button
                  variant="standard"
                  sx={{
                    borderRadius: 5,
                    fontSize: "10px",
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.light }
                  }}
                  endIcon={<Send />}
                  autoFocus
                  onClick={() =>
                    handleSubmit(
                      props.data ? props.data.OrderId : 0,
                      "Order",
                      "DODP",
                      orderDate,
                      lineItems.filter((itt) => itt.Name && itt.Name.length > 0)
                    )
                  }
                >
                  Direct D&P
                </Button>
                |
              </>
            )}
          <Button
            variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light },
              alignSelf: "end"
            }}
            endIcon={<Close />}

            onClick={() => setOpen(false)}
          >
            close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
